import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dumbledore from '../Dumbledore/Dumbledore';
class Login extends Component {

  login() {
    this.props.auth.login();
  }

  render() {
    const { isAuthenticated } = this.props.auth;

    let loginButton;
    if (!this.props.auth.isAuthenticated()) {
      loginButton = (<button className="btn" onClick={() => this.props.auth.login()}>Login</button>)
    } else {
      loginButton = (<button className="btn" onClick={() => this.props.auth.logout()}>Logout</button>)
    }

    return (
      <div className="LoginContainer container">
        {
          !isAuthenticated() && (
            <h4>
              You are not logged in! Please{' '}
              <a
                style={{ cursor: 'pointer' }}
                onClick={this.login.bind(this)}
              >
                Log In
                </a>
              {' '}to continue.
              </h4>
          )
        }
        <div>
          {loginButton}
          { this.props.showDumbledore && <Dumbledore /> }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  showDumbledore: state.ui.showDumbledore
});

export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/Login/Login.js